import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ResetPasswordService {
  constructor(private http: HttpClient) {}

  getUsernameByToken(token: string, lang: string): Observable<any> {
    const data = {
      token: token,
      language: lang,
    };
    return this.http.post(environment.apiURL + 'auth/getUsernameByToken', data);
  }

  resetPassword(
    token: string,
    password: string,
    passwordConfirmation: string,
    usernames: string,
    lang: string
  ): Observable<any> {
    const data = {
      token: token,
      password: password,
      password_confirmation: passwordConfirmation,
      usernames: usernames,
      language: lang,
    };
    return this.http.post(environment.apiURL + 'auth/resetPassword', data);
  }
}